module.exports = __webpack_public_path__ + "static/media/2B.1f9a3107.svg";